module.exports = __webpack_public_path__ + "static/img/4.5a88475.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/4.png
// module id = XYVZ
// module chunks = 0